import React from 'react';
import Navbar from './Navbar';
import { AppSettings } from '../types';

interface LayoutProps {
  children: React.ReactNode;
  currentPath: string;
  onNavigate: (path: string) => void;
  settings?: AppSettings;
  updateSettings?: (s: Partial<AppSettings>) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, currentPath, onNavigate, settings, updateSettings }) => {
  return (
    <div className="min-h-screen flex flex-col pb-8 md:pb-0 transition-colors duration-700">
      <Navbar
        currentPath={currentPath}
        onNavigate={onNavigate}
        settings={settings}
        updateSettings={updateSettings}
      />

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      <footer className="bg-cosmic-900 py-8 border-t border-cosmic-700 text-center text-cosmic-400 text-sm">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <button onClick={() => onNavigate('/about')} className="hover:text-white underline">About Us</button>
            <button onClick={() => onNavigate('/contact')} className="hover:text-white underline">Contact Us</button>
            <button onClick={() => onNavigate('/faq')} className="hover:text-white underline">FAQ</button>
            <button onClick={() => onNavigate('/methodology-tools')} className="hover:text-white underline">How Tools Work</button>
          </div>
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <button onClick={() => onNavigate('/resources')} className="hover:text-white underline">Learning Center</button>
            <button onClick={() => onNavigate('/sitemap')} className="hover:text-white underline">Site Map</button>
          </div>
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <button onClick={() => onNavigate('/privacy')} className="hover:text-white underline">Privacy Policy</button>
            <button onClick={() => onNavigate('/terms')} className="hover:text-white underline">Terms of Service</button>
            <button onClick={() => onNavigate('/editorial')} className="hover:text-white underline">Editorial Policy</button>
          </div>
          <p className="mb-2">ZodiAge is for entertainment and educational purposes only.</p>
          <p className="text-xs opacity-60">© {new Date().getFullYear()} ZodiAge. All content is provided for reflection and entertainment, not professional advice.</p>
          <p className="mt-2 text-xs opacity-60">Design by K.Levent</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
